// CompensationNormModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, InputGroup } from 'react-bootstrap';

const CompensationNormModal = ({ 
  isOpen, 
  onClose, 
  normData, 
  onSubmit,
  viewMode = false,
  isEditPossible = true,
  loading = false
}) => {
  const [formData, setFormData] = useState({
    effectiveDate: '',
    amount: '',
    currency: 'UAH',
    documentTitle: '',
    documentLink: '',
    documentDescription: '',
    isCurrent: false
  });

  useEffect(() => {
    if (normData) {
      setFormData({
        effectiveDate: normData.effectiveDate || '',
        amount: normData.amount || '',
        currency: normData.currency || 'UAH',
        documentTitle: normData.documentTitle || '',
        documentLink: normData.documentLink || '',
        documentDescription: normData.documentDescription || '',
        isCurrent: normData.isCurrent || false
      });
    } else {
      setFormData({
        effectiveDate: '',
        amount: '',
        currency: 'UAH',
        documentTitle: '',
        documentLink: '',
        documentDescription: '',
        isCurrent: false
      });
    }
  }, [normData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <Modal show={isOpen} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {viewMode 
            ? 'Перегляд норми компенсації' 
            : normData 
              ? 'Редагувати норму компенсації' 
              : 'Додати нову норму компенсації'
          }
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Дата початку дії *</Form.Label>
                <Form.Control
                  type="date"
                  name="effectiveDate"
                  value={formData.effectiveDate}
                  onChange={handleChange}
                  required={!viewMode}
                  disabled={viewMode || !isEditPossible || loading}
                  readOnly={viewMode}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Сума компенсації *</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="number"
                    name="amount"
                    value={formData.amount}
                    onChange={handleChange}
                    required={!viewMode}
                    placeholder="Введіть суму"
                    disabled={viewMode || !isEditPossible || loading}
                    readOnly={viewMode}
                  />
                  <InputGroup.Text>UAH</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              name="isCurrent"
              label="Поточна норма компенсації"
              checked={formData.isCurrent}
              onChange={handleChange}
              disabled={viewMode || !isEditPossible || loading}
              readOnly={viewMode}
            />
            <Form.Text className="text-muted">
              Відмітьте, якщо це поточна діюча норма компенсації
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Назва нормативного документа *</Form.Label>
            <Form.Control
              type="text"
              name="documentTitle"
              value={formData.documentTitle}
              onChange={handleChange}
              required={!viewMode}
              placeholder="Наприклад: Рішення Київської міської ради №123/456"
              disabled={viewMode || !isEditPossible || loading}
              readOnly={viewMode}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Посилання на документ</Form.Label>
            <Form.Control
              type="url"
              name="documentLink"
              value={formData.documentLink}
              onChange={handleChange}
              placeholder="https://kmr.gov.ua/doc/..."
              disabled={viewMode || !isEditPossible || loading}
              readOnly={viewMode}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Опис документа *</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="documentDescription"
              value={formData.documentDescription}
              onChange={handleChange}
              required={!viewMode}
              placeholder="Детальний опис нормативного документа"
              disabled={viewMode || !isEditPossible || loading}
              readOnly={viewMode}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {viewMode ? 'Закрити' : 'Скасувати'}
          </Button>
          {!viewMode && isEditPossible && (
            <Button variant="primary" type="submit" disabled={loading}>
              {loading && <Spinner animation="border" size="sm" className="me-2" />}
              {normData ? 'Зберегти зміни' : 'Додати норму'}
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CompensationNormModal;